import React from "react";

// not found component for the 404 page
const NotFound: React.FC = () => {
  return (
    <section className="page-container my-12 flex flex-col justify-center items-center gap-3">
      <h1 className="text-2xl text-center font-medium capitalize">
        sorry, this page is not found
      </h1>
    </section>
  );
};

export default NotFound;
